import React from 'react'
import { Outlet } from 'react-router-dom'

import AppHeader from 'components/AppHeader'
import style from './style.module.css'

function Layout() {
  return (
    <>
      <AppHeader />
      <div className={style.wrapper}>
        <div className={style.inner}>
          <div>
            <Outlet />
          </div>
        </div>
      </div>
    </>
  )
}

export default Layout
